import authAxios from '@/common/agent/ApiAgent';
import { OnboardingStatus } from '../model/AuthTypes';

export const getCafe24AuthRequestUrl = async (mall_id: string) => {
  const { data } = await authAxios.get<string>('/auth/oauth/cafe24', {
    params: {
      mall_id,
    },
  });

  return data;
};

export const postPlatformAuthToken = async (authorizationCode: string, state: string) => {
  const { data } = await authAxios.post('/auth/oauth/token', {
    code: authorizationCode,
    state: state,
  });
  return data;
};

export const updateStatus = async (mall_id: string, status: OnboardingStatus) => {
  const { data } = await authAxios.patch(`/auth/onboarding/${mall_id}`, {
    onboarding_status: status,
  });

  return data;
};

export const validateCafe24AppLink = (appLinkUrl: string) =>
  authAxios.post('/auth/oauth/cafe24/app-link/validation', {
    url: appLinkUrl,
  });

export const getCafe24AuthLink = async (mall_id: string) => {
  const { data } = await authAxios.get<string>('/auth/oauth/cafe24/install', {
    params: {
      mall_id,
    },
  });

  return data;
};
